import Raven from "raven-js";
import configs from "./utils/configs";

export default function registerTelemetry(trackedPage, trackedTitle) {
  const sentryDsn = configs.SENTRY_DSN;
  const gaTrackingId = configs.GA_TRACKING_ID;

  if (sentryDsn) {
    console.log("Tracking: Sentry DSN: " + sentryDsn);
    Raven.config(sentryDsn).install();
  }

  if (gaTrackingId) {
    console.log("Tracking: Google Analytics ID: " + gaTrackingId);

    /* Google tag (gtag.js) */
    document.addEventListener('DOMContentLoaded', () => {
      document.head.appendChild(document.createElement('script'))
      .src = `https://www.googletagmanager.com/gtag/js?id=${gaTrackingId}`;
    });

    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', gaTrackingId);

    if (trackedPage) {
      gtag("set", "page", trackedPage);
    }

    if (trackedTitle) {
      gtag("set", "title", trackedTitle);
    }
  }
}
